import { render, staticRenderFns } from "./Servers.vue?vue&type=template&id=3f811040&scoped=true&"
import script from "./Servers.vue?vue&type=script&lang=ts&"
export * from "./Servers.vue?vue&type=script&lang=ts&"
import style0 from "./Servers.vue?vue&type=style&index=0&id=3f811040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f811040",
  null
  
)

export default component.exports